import { ProgressBar } from "react-bootstrap";

const ProgressBarList = ({ data }) => {
  return (
    <div>
      {data?.map((item, index) => (
        <div key={index} className="mb-4">
          <div className="text-white mb-2 d-flex justify-content-between">
            <span>{item?.name}</span>
            <span>{`${item?.percentage}%`}</span>
          </div>
          <ProgressBar style={{ background: "transparent", height: "8px" }}>
            <ProgressBar
              now={item.percentage}
              style={{ backgroundColor: item.color }}
            />
          </ProgressBar>
        </div>
      ))}
    </div>
  );
};

export default ProgressBarList;
